require('./base').setActionDefaults(require('../actions/resize'));
